<template>
  <div :id="model.contentGuid" class="flex items-center justify-end">
    <div v-if="userRole === 'initiator'" class="flex items-center">
      <div>
        <button @click.prevent="openConfirmPopup"
          class="btn btn--large btn--bluedark text-white pt-5 pb-[18px] px-1 text-lg"
          :class="isSaving ? 'btn--bluedark__outline' : ''" :disabled="isSaving">
          {{ $t('schema.common.action.sendApprovalRequest') }}
        </button>
      </div>
    </div>
    <div v-if="showConfirmModal">
      <ConfirmPopUp @close="closeConfirmPopup" @confirm="send"
        :text="$t('schema.schemaPage.peerReview.sendConfirmPublish')" />
    </div>
  </div>
</template>

<script>

import ConfirmPopUp from '@/views/components/confirm/ConfirmPopUp.vue';
export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
    preview: {
      type: Boolean,
      required: false,
    },
    userRole: {
      type: String,
      required: true,
    },
  },
  components: {
    // SectionDescription,
    // SectionTitle,
    ConfirmPopUp,
  },
  data() {
    return {
      isSaving: false,
      showConfirmModal: false,
    };
  },
  methods: {
    send() {
      this.isSaving = true;
      const requestOptions = {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          assessmentId: this.pageId,
        }),
      };
      this.closeConfirmPopup();
      fetch(`${window.location.origin}/api/schema/SendApprovalRequest`, requestOptions)
        .then(() => {
          this.$emit('update');
          this.$toast.open({
            message: 'Status på mini-metodevurderingen oppdatert',
            type: 'success',
            dismissible: true,
          });
          this.isSaving = false;
        });
    },
    openConfirmPopup() {
      this.showConfirmModal = true;
    },
    closeConfirmPopup() {
      this.showConfirmModal = false;
    },
  },
  emits: ['update'],
};
</script>